// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCLZcdRu_76E7zeeLtkXTSEkJujBGFLP44",
  authDomain: "review-280c2.firebaseapp.com",
  projectId: "review-280c2",
  storageBucket: "review-280c2.appspot.com",
  messagingSenderId: "659510403723",
  appId: "1:659510403723:web:959f0e4e7691f12179aa8e",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app;
